import type { ReactElement, ReactNode } from 'react';
import styles from './Card.module.scss';

export interface CardProps {
  title?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
}

/** Карточка раздела: заголовок, действия справа, содержимое. */
export function Card({ title, actions, children, className }: CardProps): ReactElement {
  return (
    <section className={`${styles.card} ${className ?? ''}`}>
      {title || actions ? (
        <div className={styles.header}>
          {title ? <h2 className={styles.title}>{title}</h2> : <span />}
          {actions ? <div className="u-row">{actions}</div> : null}
        </div>
      ) : null}
      {children}
    </section>
  );
}
